export const my_authors = {
    
      "title":"About the author: David Pratama",
      "content":"David Pratama is a college student from University of Surabaya (Ubaya) and he likes the web development. He likes the web development like as react, laravel, and nextJS. Not only that, he always push the code and share it to everyone so everyone can learn about how to make a web easily without any confuse again. Btw you can find me out about my github page in daviddprtma. Thank you.",
    
  }